import { render, staticRenderFns } from "./PlatformIndex.vue?vue&type=template&id=40e6aa3d&scoped=true&"
import script from "./PlatformIndex.vue?vue&type=script&lang=ts&"
export * from "./PlatformIndex.vue?vue&type=script&lang=ts&"
import style0 from "./PlatformIndex.vue?vue&type=style&index=0&id=40e6aa3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e6aa3d",
  null
  
)

export default component.exports